<script>
export default {
  props: {
    totalFailed: {
      type: Number,
      required: false,
    },
    totalSuccess: {
      type: Number,
      required: false,
    },
    totalData: {
      type: Number,
      required: false,
    },
    errorFile: {
      type: String,
      required: false,
    },
    fileName: {
      type: String,
      required: false,
    },
    fileType: {
      type: String,
      required: false,
    },
  },
  methods: {
    toDownload() {
      var temp = 'data:' + this.fileType + ';base64,' + encodeURIComponent(this.errorFile)
      var download = document.createElement('a')
      download.href = temp
      download.download = 'data_gagal_' + this.fileName
      document.body.appendChild(download)
      download.click()
      document.body.removeChild(download)
    },
  },
}
</script>
<template>
  <div class="card">
    <div class="card-body">
      <div class="mc-upload">
        <div class="mc-upload-result mc-upload-result--success" v-if="totalFailed === 0">
          <figure>
            <img src="@/assets/images/success-icon.png" alt />
          </figure>
          <h4 class="mc-upload-result__label">{{ $t('uploadEmployeeSuccess') }}</h4>
          <ul class="mc-upload-result__detail">
            <li>
              <b>{{ totalSuccess + totalFailed }}</b> {{ $t('totalData') }}
            </li>
            <li class="text-success">
              <b>{{ totalSuccess }}</b> {{ $t('global.success') }}
            </li>
            <li class="text-danger">
              <b>{{ totalFailed }}</b> {{ $t('global.failed') }}
            </li>
          </ul>
        </div>
        <div
          class="mc-upload-result mc-upload-result--warning"
          v-else-if="totalFailed > 0 && totalSuccess > 0"
        >
          <figure>
            <img src="@/assets/images/warning-icon.png" alt />
          </figure>
          <h4 class="mc-upload-result__label">{{ $t('employeeUploadPartiallySuccessFul') }}</h4>
          <ul class="mc-upload-result__detail">
            <li>
              <b>{{ totalSuccess + totalFailed }}</b> {{ $t('totalData') }}
            </li>
            <li class="text-success">
              <b>{{ totalSuccess }}</b> {{ $t('global.success') }}
            </li>
            <li class="text-danger">
              <b>{{ totalFailed }}</b> {{ $t('global.failed') }}
            </li>
          </ul>
          <b-button variant="outline-primary" class="" @click="toDownload"
            ><i class="mc-fa icon-outline_download"></i> {{ $t('failedToDownload') }}</b-button
          >
        </div>
        <div class="mc-upload-result mc-upload-result--error" v-else-if="totalSuccess === 0">
          <figure>
            <img src="@/assets/images/alert-report-danger.png" alt />
          </figure>
          <h4 class="mc-upload-result__label">{{ $t('failedToUloadEmployee') }}</h4>
          <ul class="mc-upload-result__detail">
            <li>
              <b>{{ totalSuccess + totalFailed }}</b> {{ $t('totalData') }}
            </li>
            <li class="text-success">
              <b>{{ totalSuccess }}</b> {{ $t('global.success') }}
            </li>
            <li class="text-danger">
              <b>{{ totalFailed }}</b> {{ $t('global.failed') }}
            </li>
          </ul>
          <b-button variant="outline-primary" class="" @click="toDownload"
            ><i class="mc-fa icon-outline_download"></i> {{ $t('failedToDownload') }}</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
